/**
 * Centralized Route Definitions
 * Use these constants throughout the app instead of hardcoded strings.
 */
export const ROUTES = {
  HOME: "/",
  LOGIN: "/login",
  HEALTH: "/health",
  MENTORS: "/mentors",
  RISK: "/risk",
  PLGS: "/plgs",
  PLG_DETAIL: (id: string | number) => `/plgs/${id}`,
  LEARNERS: "/learners",
  MENTOR_SELECT: "/mentor",
  MENTOR_VIEW: (plgName: string) => `/mentor/${encodeURIComponent(plgName)}`,
  DATA_QUALITY: "/data-quality",
} as const;

export type AppRoute = typeof ROUTES[keyof Omit<typeof ROUTES, "PLG_DETAIL" | "MENTOR_VIEW">] | string;
